import { api } from "../../../utils/api";
import { TOKEN } from "../../../utils/localStorage";
import { getCookie } from "cookies-next";

export const getAccountDetailsListApi = async (id) => {
  return await api.get(`/user/${id}`, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};

export const updateAccountPasswordListApi = async (data) => {
  return await api.post(`/user/change-password`, data, {
    headers: {
      Authorization: `Bearer ${getCookie(TOKEN)}`,
    },
  });
};
